<script>
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { isAuthenticated, userInfo } from '@dopry/svelte-auth0';
  import { Container } from 'sveltestrap';

  onMount(async () => {
    if (
      !$isAuthenticated ||
      !$userInfo['http://techsteward.com/roles'].includes('admin')
    )
      push('/');
  });
</script>

<h5>&nbsp;> Admin > Market/Store</h5>
<br />
<Container>admin market/store stuff...</Container>
